/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ debtType: NonNullable<unknown> }} Case_Debt_Type_LabelInputs */

const en_case_debt_type_label = /** @type {(inputs: Case_Debt_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.debtType === "contractual_installment") return /** @type {LocalizedString} */ (`Contract installment`);
	if (i?.debtType === "contractual_penalty") return /** @type {LocalizedString} */ (`Contractual penalty`);
	if (i?.debtType === "return_inspection_damage") return /** @type {LocalizedString} */ (`Return inspection – damages`);
	if (i?.debtType === "traffic_fine") return /** @type {LocalizedString} */ (`Traffic fines`);
	if (i?.debtType === "other") return /** @type {LocalizedString} */ (`Other`);
	return /** @type {LocalizedString} */ (`${i?.debtType}`)
	
};

const pt_br2_case_debt_type_label = /** @type {(inputs: Case_Debt_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.debtType === "contractual_installment") return /** @type {LocalizedString} */ (`Mensalidade contratual`);
	if (i?.debtType === "contractual_penalty") return /** @type {LocalizedString} */ (`Multa contratual`);
	if (i?.debtType === "return_inspection_damage") return /** @type {LocalizedString} */ (`Checklist devolução – avarias`);
	if (i?.debtType === "traffic_fine") return /** @type {LocalizedString} */ (`Multas de trânsito`);
	if (i?.debtType === "other") return /** @type {LocalizedString} */ (`Outro`);
	return /** @type {LocalizedString} */ (`${i?.debtType}`)
	
};

/**
* | debtType | output |
* | --- | --- |
* | "contractual_installment" | "Contract installment" |
* | "contractual_penalty" | "Contractual penalty" |
* | "return_inspection_damage" | "Return inspection – damages" |
* | "traffic_fine" | "Traffic fines" |
* | "other" | "Other" |
* | * | "{debtType}" |
*
* @param {Case_Debt_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_debt_type_label = /** @type {((inputs: Case_Debt_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Debt_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_debt_type_label(inputs)
	return pt_br2_case_debt_type_label(inputs)
});